import(/* webpackMode: "eager", webpackExports: ["Skeleton"] */ "/app/src/components/ui/Skeleton.tsx");
